<template lang="html">

    <div class="academico-edit row-start" :clicked="clicked">

        <button class="erase" @click="erase" :loading="loadingerase"></button>


        <div class="inputs-wrapper row-start" v-if="!!edit" >
            <div class="contenedor-input -small" :error="errors.has('inicio') & clicked">
                <label for="">Comienzo*</label>
                <datepicker v-model="inicio" :language="es" name="inicio" :error="(errors.has('inicio') & clicked) ? 'true' : 'false'"
                    :full-month-name="true" :monday-first="true" v-validate="'required'"
                    :format="'MMMM yyyy'" :minimum-view="'month'"></datepicker>
                    <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('inicio') }}</span>
            </div>

            <div class="contenedor-input -small -fecha-fin" :error="errors.has('fin') & clicked" v-if="!!edit" >
                <label for="">Fin*</label>
                <datepicker v-model="fin" :language="es" :full-month-name="true" :disabled="edit.actualidad"
                    :monday-first="true" v-validate="(!edit.actualidad) ? 'required' : ''" name="fin" :error="(errors.has('fin') & clicked) ? 'true' : 'false'"
                    :format="'MMMM yyyy'" :minimum-view="'month'"></datepicker>

                    <div class="toggle-checkbox row-start" edit="true">
                        <input type="checkbox" :id="'actualidad-'+edit.id" name="actualidad" v-model="edit.actualidad">
                        <label :for="'actualidad-'+edit.id">actualidad</label>
                    </div>
        

                    <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('fin') }}</span>
            </div>

            <div class="contenedor-input">
                <label for="">Puesto*</label>
                <input type="text" v-model="edit.puesto" name="puesto" v-validate="'required'">
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('puesto') }}</span>
            </div>

        </div>


        <div class="inputs-wrapper row-start">

            <div class="contenedor-input">
                <label for="">Empresa*</label>
                <input type="text" v-model="edit.empresa" name="empresa" v-validate="'required'">
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('empresa') }}</span>
            </div>


            <div class="contenedor-input -no-margin">
                <label for="">Sector*</label>
                <select v-model="edit.idSector" v-validate="'required'" name="sector">
                    <option value="">Selecciona tu sector</option>
                    <option :value="sector[0]" v-for="sector in
                        dominios.sectoresActividad">{{sector[1]}}</option>
                </select>
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('sector') }}</span>
            </div>

            <div class="contenedor-input">
                <label for="">Actividad*</label>
                <select v-model="edit.idActividad" v-validate="'required'" name="actividad">
                    <option value="">Seleccionar actividad</option>
                    <option :value="actividad[0]" v-for="actividad in
                        dominios.actividadesProfesionales">{{actividad[1]}}</option>
                </select>
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('actividad') }}</span>
            </div>

            <div class="contenedor-input">
                <label for="">Enlace</label>
                <input type="text" v-if="!!edit.enlaces"
                    v-model="edit.enlaces[0]">
            </div>

        </div>

        <div class="inputs-wrapper row-start">
            <div class="contenedor-input">
                <label for="">Función*</label>
                <textarea v-model="edit.funcion" name="funcion" v-validate="'required'"></textarea>
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('funcion') }}</span>
            </div>
        </div>

        <div class="listado-adjuntos column-start">
            <p class="row-start" v-for="(adjunto, key) in edit.adjuntos"
                v-if="edit.adjuntos.length != 0">
                <button class="erase" @click="eraseAdjunto(adjunto)"></button>
                <a :href="adjunto.enlace" target="_blank">{{(!!adjunto.nombre) ?
                    adjunto.nombre : 'Fichero adjunto '+(key+1)}}</a>
            </p>
        </div>

        

        <a @click="showdropzone= true" v-if="!showdropzone" class="add-btn">Añadir
            documento</a>
            

        <dropzone v-if="showdropzone" @emit="setDoc" ref="dropzone"></dropzone>
    </div>


</template>

<script lang="js">

    import Datepicker from 'vuejs-datepicker';

    import { en, es } from 'vuejs-datepicker/dist/locale'

    import dropzone from '@/components/parts/dropzone';

    import {mapGetters, mapActions} from 'vuex';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    export default {
        name: 'profesional-edit',
        props : ['data','clicked'],
        mounted(){
            if(!!this.data){

                for(let i in this.data){
                    this.edit[i] = this.data[i]
                }
                
                let inicio = new Date(this.edit.anioinicio, this.edit.mesinicio-1);

                let fin;

                if(this.edit.aniofin != 'Actualidad'){
                    fin = new Date(this.edit.aniofin, this.edit.mesfin-1);
                    this.edit.actualidad = false;
                }else{
                    fin = new Date();
                    this.edit.actualidad = true;
                }
                this.inicio = inicio;
                this.fin = fin;
                (!!!this.edit.enlaces) ? this.edit.enlaces = [] : null;
                setTimeout(e => {
                    this.checkData();
                },150)

            }else{
                this.edit = {
                    id: '',
                    puesto: "",
                    empresa: "",
                    sector: null,
                    idSector:'',
                    actividad: null,
                    idActividad: '',
                    mesinicio: "",
                    anioinicio: "",
                    mesfin: "",
                    aniofin: "",
                    funcion: "",
                    enlaces: [],
                    adjuntos: [],
                    allok : false,
                    actualidad : false
                }
            }

            //SETEO DE ARRAY EN LOS ENLACES


        },
        data() {
            return {
                en: en,
                es: es,
                inicio: '',
                fin: '',
                showdropzone: false,
                edit : {
                    actualidad : false
                },
                loadingerase : false
            }
        },
        methods : {
            ...mapActions(['eraseExperiencia']),
            setDoc(value) {
                let adjunto = {
                    "id": '',
                    "fecha": "",
                    "tipo": "",
                    "enlace": "",
                    "nombre": "",
                    "ficheroB64ParaAltas": "",
                    "extension_adjunto": "",
                    "idDocumentoNecesarioOfertaNoTipado": 0
                }

                for(let i in value){
                    adjunto[i] = value[i];
                }

                this.edit.adjuntos.push(adjunto);

                this.$refs.dropzone.reset();

                this.showdropzone = false;
            },
            eraseAdjunto(adjunto){
                if(!!adjunto.id){
                    this.edit.adjuntos = this.edit.adjuntos.filter(a => a.id != adjunto.id)
                }
            },
            erase(){

                if(!!this.edit.id){
                    this.loadingerase = true;
                    this.eraseExperiencia(this.edit.id).then(r => {
                        this.$emit('erase',this.edit);
                        this.loadingerase = false;
                    });
                }else{
                    this.$emit('erase',this.edit);
                }
            },
            checkData(){

                console.log("AAAA");
                
                this.$validator.validateAll().then(canSend => {
                    
                    if (canSend) {
                        

                        let inicio = new Date(this.inicio);
                        
                        this.edit.mesinicio = inicio.getMonth()+1;
                        this.edit.anioinicio = inicio.getFullYear();

                        if(!this.edit.actualidad){

                            let fin = new Date(this.fin);
                            
                            this.edit.mesfin = fin.getMonth()+1;
                            this.edit.aniofin = fin.getFullYear();
                        }else{
                            this.edit.aniofin = 'actualidad';
                        }


                        this.edit.allok = true;
                        
                        this.$emit('input', this.edit);
                    }else{
                        this.edit.allok = false;
                        this.$emit('input', this.edit);
                    }
                });
            }
        },
        components: {
            Datepicker,
            'dropzone': dropzone
        },
        computed : {
            ...mapGetters({
                dominios : 'getDominiosOrder',
                rawdominios : 'getDominios'
            })
        },
        watch : {
            'edit': {
                deep: true,
                handler(){
                    this.checkData();
                }
            },
            'inicio'(){
                this.checkData();
            },
            'fin'(){
                this.checkData();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .academico-edit > .erase {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 5;
    }


  .contenedor-input select[aria-invalid="true"], .contenedor-input input[aria-invalid="true"], .contenedor-input textarea[aria-invalid="true"]{
    background-color:transparent;
  }

  [clicked=true]{
  .contenedor-input select[aria-invalid="true"],
  .contenedor-input input[aria-invalid="true"],
  .contenedor-input textarea[aria-invalid="true"]{
    background-color: rgba(255,0,0,0.4);
  } 
}

</style>


// WEBPACK FOOTER //
// src/components/parts/experiencia-edit.vue